import request from '../utils/request';

export function getAllOrders(headers) {
    return request({
        partialUrl: `/API/Order/GetOrders`,
        method: 'GET',
        state: headers,
        body: {}
    })
        .then(response => response.json())
        .then(data => { return data })
        .catch(err => { return err })
}